import { lazyClickAttachment, PreviewPaneSelectionSource } from 'owa-attachment-select-actions';
import { onAfterSelectionChanged } from 'owa-mail-actions/lib/mailListSelectionActions';
import { listViewStore } from 'owa-mail-list-store';
import { getRowIdString } from 'owa-mail-list-store/lib/selectors/mailRowDataPropertyGetter';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import { MailListItemSelectionSource } from 'owa-mail-store';
import { lazyCreateImageGalleryFromAttachmentViewStateIds, sxsStore } from 'owa-sxs-store';
import { lazyActivateTab, primaryTab } from 'owa-tab-store';
import { orchestrator } from 'satcheljs';

orchestrator(onAfterSelectionChanged, actionMessage => {
    if (
        actionMessage.mailListItemSelectionSource ===
        MailListItemSelectionSource.MailListItemRichPreview
    ) {
        const rowId = getRowIdString(actionMessage.rowKey, actionMessage.tableView);

        const attachmentViewStateId = sxsStore.attachmentViewStateIdFromListView;
        const attachmentViewState = listViewStore.attachmentViewStates.get(attachmentViewStateId);

        const instrumentationContexts = getInstrumentationContextsFromTableView(
            [actionMessage.rowKey],
            actionMessage.tableView
        );

        // Switch to primary tab immediately
        // so that SxS can copy the correct reading pane information
        lazyActivateTab.importAndExecute(primaryTab);
        lazyClickAttachment(
            attachmentViewState,
            PreviewPaneSelectionSource.MailList,
            instrumentationContexts[0],
            attachmentViewState.parentItemId,
            false, // isDraft: used to determine if attachment can be edited in SxS
            null, // onBeforePreview
            async () => {
                const createImageGalleryFromAttachmentViewStateIds = await lazyCreateImageGalleryFromAttachmentViewStateIds.import();
                return createImageGalleryFromAttachmentViewStateIds(
                    listViewStore.rowAttachmentPreviewWellViews.get(rowId).imageViewStateIds,
                    id => listViewStore.attachmentViewStates.get(id)
                );
            }
        );
    }
});
